import { post } from '../../services/api';
import React, { useState, useEffect, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TailSpin } from "react-loader-spinner";
import Select from 'react-select';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import imagemExemplo from '../../assets/img/exemplo-arquivo-suricato.png'

export default function VendasSuricato() {
    const [file, setFile] = useState(null);
    const [isFetchingDataImportacao, setIsFetchingDataImportacao] = useState(false);
    const [vendas, setVendas] = useState([]);
    const [filiais, setFiliais] = useState(null);
    const [isFetchingDataFiltro, setIsFetchingDataFiltro] = useState(false);
    const [filtroFilial, setFiltroFilial] = useState(null);
    const inputRef = useRef(null);
    const [mesAnoImportacao, setMesAnoImportacao] = useState(null);
    const [mesAnoFiltro, setMesAnoFiltro] = useState(null);
    const [paginaSelecionada, setPaginaSelecionada] = useState(1);

    useEffect(() => {
        carregarMesAnoPadroes();
        getVendas();
        fetchFiliais();
    }, []); 

    async function getVendas() {
        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();
  
        const mesAnoPadrao = `${mesAtual}-${anoAtual}`;
         
        let mes, ano;
        [mes, ano] =   (mesAnoFiltro !== null) ? mesAnoFiltro.value.split('-') : mesAnoPadrao.split('-');

        const idfilial = (filtroFilial !== null) ? filtroFilial.value : 0;
        const requisicao = { mes: mes, ano: ano, filial: idfilial };
        const authToken = localStorage.getItem('adminToken');

        setIsFetchingDataFiltro(true);
        const response = await post('/admin/vendassuricato', requisicao, authToken);
        setIsFetchingDataFiltro(false);

        setVendas(response);
    }

    const confirmarImportacao = () => {
        if (!file) {
            toast.error('Nenhum arquivo selecionado.');
            return;
        }

        withReactContent(Swal).fire({
            title: <i>Deseja importar?</i>,
            html: 'As informações já existentes serão atualizadas!',
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            confirmButtonColor: "green",
        }).then((result) => {
            if (result.isConfirmed) {
                importarVendas();
            }
        });
    };

    async function importarVendas() {
        try {
            handleChangeFilial(null);

            let mes, ano;
            [mes, ano] = mesAnoImportacao.value.split('-');

            const idUsuario = localStorage.getItem("idusuario");
            const formData = new FormData();
            const authToken = localStorage.getItem('adminToken');

            formData.append('file', file);
            formData.append('idusuario', idUsuario);
            formData.append('mes', mes);
            formData.append('ano', ano);

            setIsFetchingDataImportacao(true);
            const response = await post('/admin/importarvendassuricato', formData, authToken);
            setIsFetchingDataImportacao(false);

            if (response.Sucesso === true) {
                toast.success(response.Mensagem);
                setFile(null);
                inputRef.current.value = null;
                mesAnoFiltro.value = mesAnoImportacao.value;
                mesAnoFiltro.label = mesAnoImportacao.label;
                getVendas();

            } else {
                toast.error(response.Mensagem);
                setFile(null);
                inputRef.current.value = null;
            }
        } catch (error) {
            toast.error('Erro durante a importação.');
            console.error('Erro durante a importação:', error);
        }
    }

    function carregarMesAnoPadroes () {
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];
  
        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();
  
        const mesAnoPadrao = {
          value: `${mesAtual}-${anoAtual}`,
          label: `${meses[mesAtual - 1]}/${anoAtual}`
        };
  
        setMesAnoImportacao(mesAnoPadrao);
        setMesAnoFiltro(mesAnoPadrao);
    }

    function getPaginacao() {
        const ITENS_POR_PAGINA = 15;

        const paginasTotais = Math.ceil(vendas.length / ITENS_POR_PAGINA);

        const startIndex = (paginaSelecionada - 1) * ITENS_POR_PAGINA;
        const endIndex = startIndex + ITENS_POR_PAGINA;

        const currentVendas = (vendas && vendas.length > 0) ? vendas.slice(startIndex, endIndex) : [];

        return {
            paginasTotais: paginasTotais,
            currentVendas: currentVendas
        }
    }

    function formatoMoeda(value) {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
    }

    const handleChangeMesAnoImportacao = (selectedOption) => {
        setMesAnoImportacao(selectedOption);
    };

    const handleChangeMesAnoFiltro = (selectedOption) => {
        setMesAnoFiltro(selectedOption);
    };

    const handleChangeFilial = async (selectedOption) => {
        setFiltroFilial(selectedOption);
    };

    const handleChangePagina = (pagina) => {
        setPaginaSelecionada(pagina);
    };

    async function fetchFiliais() {
        const requisicao = { idRegiao: 0 }
        const filiais = await post('/vendedores/filiais', requisicao);
        setFiliais(filiais);
    }

    const optionsFiliais = Array.isArray(filiais) ? filiais.map((filial) => ({
        value: filial.cod_sabium,
        label: filial.cod_sabium - 10000 + ' - ' + filial.nome,
    })) : [];


    const optionsMeses = () => {
        const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

        const dataAtual = new Date();
        const mesAtual = dataAtual.getMonth() + 1;
        const anoAtual = dataAtual.getFullYear();

        const options = [];

        const maximoMesesFiltro = 2;
        for (let i = 0; i < maximoMesesFiltro; i++) {
            let mes = mesAtual - i;
            let ano = anoAtual;

            if (mes <= 0) {
                mes += 12;
                ano -= 1;
            }

            const mesLabel = meses[mes - 1]; // Subtrai 1 para compensar o índice baseado em zero
            const optionValue = `${mes}-${ano}`;
            const optionLabel = `${mesLabel}/${ano}`;
            options.unshift({ value: optionValue, label: optionLabel });
        }

        return options;
    }

    const mensagemNenhumaOpcaoAlternativa = () => 'Nenhuma opção disponível';

    return (<>
        <div className="bg-white py-5 px-5 mb-5">
            <h2 className="text-black font-medium text-base">Importar Vendas</h2>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 py-4">
                <div>
                    <label
                        htmlFor="formFile"
                        className="mb-1 inline-block text-neutral-700 dark:text-neutral-200"
                    >Arquivo CSV <a className="my-anchor-element">&#10067;</a></label>
                    <input
                        className="block w-full text-sm text-gray-900 border rounded-lg cursor-pointer dark:text-gray-400 focus:outline-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
                        id="file_input"
                        type="file"
                        accept=".csv"
                        onChange={(e) => setFile(e.target.files[0])}
                        style={{ height: '40px', padding: '6px' }}
                        ref={inputRef}
                    />
                </div>

                <div>
                    <label
                        htmlFor="periodo"
                        className="mb-1 inline-block text-neutral-700 dark:text-neutral-200"
                    >Período</label>
                    <div className="select-container">
                        <Select
                            name="periodo"
                            id="periodo"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={mesAnoImportacao}
                            onChange={handleChangeMesAnoImportacao}
                            options={optionsMeses()}
                            isClearable={false}
                            isSearchable={false}
                            placeholder="Selecione o mês"
                        />
                    </div>
                </div>
            </div>

            <div className="text-right mt-6">
                <button type="button" onClick={confirmarImportacao} className="bg-green-c6 py-2 px-14 inline-block rounded-[4px] font-bold text-sm text-white">
                    {isFetchingDataImportacao ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <TailSpin color="#ffffff" height={20} width={39} />
                        </div>
                    ) : (
                        "Importar"
                    )}
                </button>
            </div>

            <ToastContainer />
            <Tooltip anchorSelect=".my-anchor-element" place="top">
                <img src={imagemExemplo} alt="Exemplo" />
            </Tooltip>

        </div>

        <div className="bg-white py-5 px-5 mb-5">
            <h2 className="text-black font-medium text-base">Filtrar</h2>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 py-4">
                <div>
                    <label
                        htmlFor="filial"
                        className="mb-1 inline-block text-neutral-700 dark:text-neutral-200"
                    >Filial</label>
                    <div className="select-container" style={{ width: '100%' }}>
                        <Select
                            name="filial"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={filtroFilial}
                            onChange={handleChangeFilial}
                            options={optionsFiliais}
                            isClearable={true}
                            placeholder="Todas"
                            noOptionsMessage={mensagemNenhumaOpcaoAlternativa}

                        />
                    </div>
                </div>

                <div>
                    <label
                        htmlFor="periodo"
                        className="mb-1 inline-block text-neutral-700 dark:text-neutral-200"
                    >Período</label>
                    <div className="select-container">
                        <Select
                            name="periodo"
                            id="periodo"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={mesAnoFiltro}
                            onChange={handleChangeMesAnoFiltro}
                            options={optionsMeses()}
                            isClearable={false}
                            isSearchable={false}
                            placeholder="Selecione o mês"
                        />
                    </div>
                </div>
            </div>

            <div className="text-right mt-6">
                <button type="button" onClick={getVendas} className="bg-green-c6 py-2 px-14 inline-block rounded-[4px] font-bold text-sm text-white">
                    {isFetchingDataFiltro ? (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <TailSpin color="#ffffff" height={20} width={39} />
                        </div>
                    ) : (
                        "Filtrar"
                    )}
                </button>
            </div>
        </div>

        <div style={{ overflowX: 'auto', display: 'grid' }}>
            <table id="table-pontuacao-geral" className="table-admin">
                <thead>
                    <tr>
                        <th>Filial</th>
                        <th>Realizado</th>
                        <th>Projetado</th>
                        <th>Mês</th>
                        <th>Ano</th>
                        <th>Usuário</th>
                    </tr>
                </thead>
                <tbody>
                    {getPaginacao().currentVendas.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="text-center">
                                Nenhum resultado encontrado
                            </td>
                        </tr>
                    ) : (
                        getPaginacao().currentVendas.map((item, index) => (
                            <tr key={index}>
                                <td>{item.numerofilial}</td>
                                <td>{formatoMoeda(item.realizado)}</td>
                                <td>{formatoMoeda(item.projetado)}</td>
                                <td>{item.mes}</td>
                                <td>{item.ano}</td>
                                <td>{item.usuario}</td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                {Array.from({ length: getPaginacao().paginasTotais }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => handleChangePagina(index + 1)}
                        style={{
                            margin: '0 5px',
                            padding: '5px 10px',
                            cursor: 'pointer',
                            backgroundColor: paginaSelecionada === index + 1 ? '#ff0000' : '#ffffff',
                            color: paginaSelecionada === index + 1 ? '#ffffff' : '#000000',
                            border: '1px solid #ff0000',
                            borderRadius: '5px',
                        }}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>
        </div>

    </>
    );
}
